import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/perf-lite.css";     // lite-graphics overrides (gated by html.perf-lite)
import "@/i18n";              // initialize translations BEFORE rendering
import App from "@/App";
import { applyPerfMode } from "@/perfMode";

applyPerfMode();              // tag <html> with perf-lite on touch / low-power devices

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
